import { render } from "./DiseaseType.vue?vue&type=template&id=74428002&ts=true"
import script from "./DiseaseType.vue?vue&type=script&lang=ts"
export * from "./DiseaseType.vue?vue&type=script&lang=ts"

import "./DiseaseType.vue?vue&type=style&index=0&id=74428002&lang=less"

import exportComponent from "/Users/junyichen/AffaMed/hda-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__